import { render, staticRenderFns } from "./SkeletonItem.vue?vue&type=template&id=6ad6fc8d"
import script from "./SkeletonItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports